import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute inset-0 flex items-center" }

import { computed } from "vue"

interface Props {
    color?: string
    text?: string
    textAlignment?: "start" | "center" | "end"
    textDivClass?: string
    textStyle?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsSeparator',
  props: {
    color: { default: "border-gray-300" },
    text: {},
    textAlignment: { default: "center" },
    textDivClass: {},
    textStyle: { default: "bg-white" }
  },
  setup(__props: any) {

const props = __props

const separatorTextAlignment = computed(() => `justify-${props.textAlignment}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full border-t", _ctx.color])
      }, null, 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['relative flex text-sm', separatorTextAlignment.value, _ctx.textDivClass])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass([_ctx.textStyle, 'px-2 text-gray-500'])
      }, _toDisplayString(_ctx.text), 3)
    ], 2)
  ]))
}
}

})